<script setup lang="ts">
import { type HTMLAttributes } from 'vue'
import { cn } from '@gat-ship/vue-components'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    orientation?: 'horizontal' | 'vertical'
  }>(),
  {
    orientation: 'horizontal'
  }
)
</script>

<template>
  <div role="separator" :class="cn(
    'relative flex items-center before:absolute before:left-0 before:bg-neutral-200 dark:before:bg-neutral-700',
    {
      'h-1 w-full before:top-1/2 before:h-px before:w-full before:-translate-y-1/2':
        props.orientation === 'horizontal',
      'h-full w-px before:left-1/2 before:h-full before:w-1 before:w-px before:-translate-x-1/2':
        props.orientation === 'vertical'
    },
    props.class
  )
    "></div>
</template>
